import { FunctionalComponent, h, Fragment } from "preact";
import { useState, useEffect, useRef, useCallback } from "preact/compat";
import LazyLoad from "react-lazyload";
// import * as style from "./style.css";
import * as style from "./style.less";
import { articleList } from "../../data/articleList";

import PartnersView from "../../components/partners-viewv";
// import ConsultView from "../../components/consult-view";
import Switch from "../../components/Switch";

const Home: FunctionalComponent = () => {
  interface FormInfo {
    createType: string;
    title: string;
    content: string;
    input: {
      actionType: string;
      useDigital: boolean;
      categoryId: number;
      mode: boolean;
      products: Array<any>;
      aiPicture: boolean;
      aiPictureStyle: string;
    };
  }

  interface Task {
    task_id: string;
    result: {
      title: string;
      thumb: string;
      video_width: string;
      video_height: string;
    };
    input: {
      content: string;
    };
  }
  interface ListItem {
    task: Task;
    category_info?: {
      value: string;
      zkIconfont: string;
      label: string;
    };
  }

  interface ProductsItem {
    id: number;
    title: string;
    eng_title: string;
    hidden: boolean;
    folderOnly: boolean;
    thumb: string
  }

  interface AiPictureStyleItem {
    label: string;
    label_en: string;
    value: string;
    logo: string;
  }

  const [siteLang] = useState("zh");
  const [playUrl, setPlayUrl] = useState("");
  const [cardIndex, setCardIndex] = useState(0);
  const [articleCount, setarticleCount] = useState(3);
  const [newListStyle, setNewListStyle] = useState({});
  const [formInfo, setFormInfo] = useState<FormInfo>({
    createType: "cut_video",
    title: "",
    content: "",
    input: {
      actionType: "ai_video",
      useDigital: false,
      categoryId: 1,
      mode: true,
      products: [],
      aiPicture: false,
      aiPictureStyle: ''
    }
  });
  const [actionTypes] = useState([
    { label: "AI创作", value: "ai_video" },
    { label: "文案成片", value: "text_video" }
  ]);
  const [tabValue, setTabValue] = useState("is_pick");
  const [list, setList] = useState<ListItem[]>([]);
  const [showAiPiPei, setShowAiPiPei] = useState(false);
  const [aiPiPeiTxt, setAiPiPeiTxt] = useState(siteLang === 'en'? 'Smart Match' : '智能匹配');

  const [loadingData, setLoadingData] = useState(false);
  const [products, setProducts] = useState<ProductsItem[]>([{
    "id": 0,
    "title": "智能匹配",
    "eng_title": "Smart Match",
    "hidden": true,
    "folderOnly": true,
    "thumb": "//rmt-oss.zaker.cn/yiqijian_images/logo_aipipei.png"
  }]);

  const [categorys] = useState([
    { label: "精选", value: "is_pick" },
    { label: "知识分享", value: "1", zkIconfont: "zk-zhishifenxiang" },
    { label: "新闻", value: "2", zkIconfont: "zk-xinwen" },
    { label: "营销推广", value: "7", zkIconfont: "zk-yingxiaotuiguang" },
    { label: "励志鸡汤", value: "3", zkIconfont: "zk-lizhijitang" },
    { label: "故事", value: "4", zkIconfont: "zk-gushi" },
    // { label: "菜谱", value: "5", zkIconfont: "zk-caipu" },
    { label: "读书笔记", value: "6", zkIconfont: "zk-dushubiji" }
  ]);

  const [aiPictureStyle, setAiPictureStyle] = useState<AiPictureStyleItem[]>([]);

  const modeEntryRef = useRef(null);
  const switchCards = (type: String): void => {
    let nextIndex = cardIndex;
    switch (type) {
      case "prev":
        if (cardIndex >= 1) {
          nextIndex -= 1;
          setCardIndex(cardIndex - 1);
        }
        break;
      case "next":
        if (cardIndex < articleList.length - 3) {
          nextIndex += 1;
          setCardIndex(cardIndex + 1);
        }
        break;
      default:
        break;
    }
    setNewListStyle({ transform: `translateX(${nextIndex * -350}px)` });
  };

  const loadArticle = () => {
    let count = articleCount;
    if (count + 3 >= articleList.length - 1) {
      count += 3;
    } else {
      count = articleList.length;
    }
    setarticleCount(count);
  };

  const getAiPictureStyleTitle = useCallback(() => {
    let value = formInfo.input.aiPictureStyle
    let title = '';
    for(let i=0; i<aiPictureStyle.length; i++){
      let item = aiPictureStyle[i]
      if(item.value === value){
        title = item.label
        break;
      }
    }
    return title
  }, [aiPictureStyle, formInfo])

  const onChangeAiPiPei = useCallback(() => {
    setShowAiPiPei(!showAiPiPei)
  }, [showAiPiPei]);

  const onSelectProducts = (item: ProductsItem, event: MouseEvent) => {
    event.stopPropagation();
    setFormInfo((prev) => ({
      ...prev,
      input: {
        ...prev.input,
        products: [{...item}],
        aiPicture: false,
        aiPictureStyle: '',
        useDigital: prev.input.useDigital
        // useDigital: item.id > 0 ? false : prev.input.useDigital
      }
    }));
    let txt = siteLang === 'en' && item.eng_title ? item.eng_title : item.title
    setAiPiPeiTxt(txt)
    setShowAiPiPei(false)
  };

  const onSelectAiPictureStyle = (item: AiPictureStyleItem) => {
    let {label, label_en, value} = item
    setFormInfo((prev) => ({
      ...prev,
      input: { ...prev.input, aiPictureStyle: value, aiPicture: true, products: [], useDigital: false }
    }));
    let txt = siteLang === 'en' && label_en ? label_en : label
    setAiPiPeiTxt(txt)
    setShowAiPiPei(false)
  };

  const onChangeCategoryId = useCallback(() => {
    let categoryId = formInfo.input.categoryId === 1 ? 2 : 1
    setFormInfo((prev) => ({
      ...prev,
      input: {
        ...prev.input,
        categoryId: categoryId,
        useDigital: categoryId === 2 ? false : prev.input.useDigital
      }
    }));
  }, [formInfo]);

  const clickActionType = (value: string) => {
    setFormInfo((prev) => ({
      ...prev,
      input: { ...prev.input, actionType: value }
    }));
  };

  const getProducts = useCallback(async () => {
    let nProducts = [{...products[0]}]
    setFormInfo({
      ...formInfo,
      input: { ...formInfo.input, products: nProducts }
    })
    try {
      const response = await fetch(
        `//ai.yiqijian.com/cms/api/similar_video/ai_build_common/media_product_list?main_org_id=90007`,
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const res = await response.json();
      if (res.stat === 1) {
        const data = res.data || {};
        const list = data.list || []
        const ai_picture_style_list = data.ai_picture_style_list || []
        setProducts(products.concat(list));
        setAiPictureStyle(ai_picture_style_list)
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
    } finally {}
  }, [formInfo, products]);

  const loadData = async () => {
    if (loadingData) return;
    setLoadingData(true);
    const params: any = {
      page: 1,
      pageSize: 12,
      ...(tabValue !== "is_pick" ? { category: tabValue } : { is_pick: "1" }),
    };
    const paramsStr = Object.keys(params)
      .map((key) => `${key}=${params[key]}`)
      .join("&");
    try {
      const response = await fetch(
        `//ai.yiqijian.com/cms/api/similar_video/ai_build_common/case_list?${paramsStr}&main_org_id=90007`,
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const res = await response.json();

      if (res.stat === 1) {
        const data = res.data || {};
        const fetchedList = (data.list || []).map((item: any) => ({
          ...item,
          category_info: categorys.find((cat) => cat.value === item.category) || {},
        }));
        setList(fetchedList);
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
    } finally {
      setLoadingData(false);
    }
  };

  const navigateWithData = (data: any) => {
    const dataStr: string = window.btoa(encodeURIComponent(JSON.stringify(data)));
    const targetUrl: string = `//ai.yiqijian.com/yiqijian_flow.html?info=${dataStr}&site_lang=zh`
    window.open(targetUrl);

    // const iframeId = "data-transfer-iframe";
    // const iframeUrl = "https://saas-dev.imp360.cn/cms/yiqijian_flow.html";
    // // 检查是否已存在 iframe
    // let iframe = document.getElementById(iframeId) as HTMLIFrameElement;
    // if (!iframe) {
    //   iframe = document.createElement("iframe");
    //   iframe.id = iframeId;
    //   iframe.style.display = "none"; // 隐藏 iframe
    //   iframe.src = iframeUrl;
    //   document.body.appendChild(iframe);
    // }
    // // 等待 iframe 加载完成后发送数据
    // iframe.onload = () => {
    //   try {
    //     // 发送数据到
    //     iframe.contentWindow?.postMessage(
    //       { type: "TRANSFER_DATA", payload: data },
    //       "https://saas-dev.imp360.cn"
    //     );
    //   } catch (error) {
    //     console.error("Failed to send data to iframe:", error);
    //   } finally {
    //     // 延迟移除 iframe，确保数据发送完成
    //     setTimeout(() => {
    //       document.body.removeChild(iframe);
    //     }, 200);
    //   }
    // };
  };
  const createTask = () => {
    if (!formInfo.content) return;

    const payload = {
      ...formInfo,
      input: formInfo.input
    };
    navigateWithData(payload);
  };

  const adjustAnimationDuration = () => {
    const loopLogos = document.getElementById("loopLogos");
    if (loopLogos) {
      const imgs = loopLogos.querySelector(".imgs") as HTMLElement;
      if (imgs) {
        const totalWidth = imgs.scrollWidth;
        const duration = totalWidth / 50; // 50px/s
        imgs.style.animationDuration = `${duration}s`;
      }
    }
  };
  useEffect(() => {
    adjustAnimationDuration();
  }, []);

  useEffect(() => {
    getProducts()
    loadData();
  }, [tabValue]);

  return (
    <div class={style.home}>
      <section class={style.modeEntry}>
        <div class={style.aniSvg}>
          <img src="https://rmt-oss.zaker.cn/yiqijian_images/dian.jpg" />
        </div>
        
        <div class={style.modeEntryCon}>
          <div class={style.mhd}>
            <div class={style.mhdcon}>
              <h1 class={style.mtitle}>
                <span class={style.t1}>全球首个免费</span>
                <span class={style.t2}>AI视频创作智能体</span>
              </h1>
              <div class={style.subtitle}>
                <span class={style.subtitletxt}>提供想法，让AI直接交付视频</span>
              </div>
            </div>
          </div>
          <div class={style.mcontent}>
            {showAiPiPei && (
              <div class={style.aipipeibg} onClick={() => onChangeAiPiPei()}></div>
            )}
            <textarea
              class={style.contentinput}
              placeholder={`${formInfo.input.actionType === 'ai_video' ? '可以输入您的视频创作需求（如主题、字数要求等）或导入链接进行二创(支持主流短视频平台和新闻网站链接）' : '请直接输入您的完整视频文案，我们将严格根据您提供的文本内容生成视频，确保100%忠实于原稿。'}`}
              rows={4}
              cols={20}
              value={formInfo.content}
              onChange={(e) => {
                let maxNum = 1000;
                let content = (e.target as HTMLTextAreaElement).value;
                // 判断是否包含中文字符
                const isChinese = /[\u4e00-\u9fa5]/.test(content);
                if (isChinese) {
                  // 按中文字符数量限制
                  const chineseContent = content.slice(0, maxNum); // 截取前 1000 个字符
                  content = chineseContent;
                } else {
                  maxNum = maxNum + 1;
                  // 按英文空格数量限制
                  const words = content.split(/\s+/); // 按空格分割单词
                  if (words.length > maxNum) {
                    content = words.slice(0, maxNum).join(" "); // 截取前 1000 个单词
                  }
                }
                setFormInfo((prev) => ({
                  ...prev,
                  content: content
                }))
              }}
            ></textarea>
            <div class={`${style.footActions} ${style.footActionsMobile}`}>
              {showAiPiPei && (
                <div
                  class={`${style.popSelect} ${style.popAipipei}`}
                  onClick={(e) => e.stopPropagation()}
                >
                  <div class={style.aipipeicon}>
                    {/* 网络素材 style={{ marginBottom: "20px" }} */}
                    <div class={style.mlist}>
                      <div class={style.lhd}>
                        <div class={style.conl}>
                          <div class={style.title}>网络素材</div>
                          <div class={style.tips}>
                            海量高质量素材库满足全场景视频制作1
                          </div>
                        </div>
                        <div class={style.conr}>
                          <label class={style.checkboxCon}>
                            <input
                              type="checkbox"
                              disabled={formInfo.input.aiPicture}
                              checked={formInfo.input.useDigital}
                              onChange={(e) => {
                                const target = e.target as HTMLInputElement;
                                setFormInfo((prev) => ({
                                  ...prev,
                                  input: { ...prev.input, useDigital: target.checked },
                                }))
                              }}
                            />
                            使用数字人
                          </label>
                        </div>
                      </div>
                      <div class={`${style.lbd} ${style.items}`}>
                        {products.map((item, index) => (
                          <div
                            key={index}
                            class={`${style.item} ${(formInfo.input.products[0] && formInfo.input.products[0].id === item.id) ? style.cur : ""}`}
                            onClick={(event) => onSelectProducts(item, event)}
                          >
                            <div class={style.pic}>
                              <img src={item.thumb} alt={siteLang === 'en' && item.eng_title ? item.eng_title : item.title} />
                            </div>
                            <div class={`text-2-clamp ${style.name}`}>
                              {siteLang === 'en' && item.eng_title ? item.eng_title : item.title}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* AI素材 */}
                    <div class={style.mlist}>
                      <div class={style.lhd}>
                        <div class={style.conl}>
                          <div class={style.title}>AI素材</div>
                          <div class={style.tips}>
                            AI根据创作脚本自动生成风格场景素材
                          </div>
                        </div>
                        <div class={style.conr}></div>
                      </div>
                      <div class={`${style.lbd} ${style.items}`}>
                        {aiPictureStyle.map((item, index) => (
                          <div
                            key={index}
                            class={`${style.item} ${(formInfo.input.aiPictureStyle === item.value) ? style.cur : ""}`}
                            onClick={(e) => {
                              e.stopPropagation();
                              onSelectAiPictureStyle(item);
                            }}
                          >
                            <div class={style.pic}>
                              <img src={item.logo} alt={siteLang === 'en' && item.label_en ? item.label_en : item.label} />
                            </div>
                            <div class={`text-2-clamp ${style.name}`}>
                              {siteLang === 'en' && item.label_en ? item.label_en : item.label}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  {/* <div class={style.aipipeibg} onClick={() => onChangeAiPiPei()}></div> */}
                </div>
              )}

              <div class={style.conl}>
                {actionTypes.map((item, index) => (
                  <Fragment>
                  {(item.value === formInfo.input.actionType) && (
                    <div
                      key={index}
                      class={`${style.btn} ${item.value === formInfo.input.actionType ? style.cur : ""}`}
                      onClick={() => clickActionType(item.value == 'ai_video' ? 'text_video' : 'ai_video')}
                    >
                      <span class={style.value}>{item.label}</span>
                      <span class={`zk-iconfont zk-paixuxuanze`}></span>
                    </div>
                  )}
                  </Fragment>
                ))}

                <div class={`${style.btn} ${showAiPiPei ? style.cur : ""}`}
                  onClick={() => onChangeAiPiPei()}
                >
                  {aiPiPeiTxt}
                  <span className="zk-iconfont zk-paixuxuanze"></span>
                </div>

                <div class={style.btn} onClick={onChangeCategoryId}>
                  <span class={style.label}>比例</span>
                  <span class={style.value}>
                    {formInfo.input.categoryId === 1 ? "9:16" : "16:9"}
                  </span>
                  <span className="zk-iconfont zk-paixuxuanze"></span>
                </div>
                
              </div>
              <div class={style.conr}>
                <div
                  class={`${style.btn} ${style.btnSend} ${formInfo.content ? style.btnSendok : ""}`}
                  onClick={createTask}
                >
                  <span className="zk-iconfont zk-zuojiantou1" style="color: #ffff; font-size: 22px; transform: rotate(90deg);"></span>
                </div>
              </div>
            </div>
            <div class={`${style.footActions} ${style.footActionsPc}`}>
              <div class={style.conl}>
                {actionTypes.map((item, index) => (
                  <div
                    key={index}
                    class={`${style.btn} ${item.value === formInfo.input.actionType ? style.cur : ""}`}
                    onClick={() => clickActionType(item.value)}
                  >
                    {item.label}
                  </div>
                ))}
              </div>
              <div class={style.conr}>
               
                <div class={`${style.btn} ${showAiPiPei ? style.cur : ""}`}
                  onClick={() => onChangeAiPiPei()}
                >
                  {aiPiPeiTxt}
                  <span className="zk-iconfont zk-paixuxuanze"></span>
                  {showAiPiPei && (
                    <div
                      class={`${style.popSelect} ${style.popAipipei}`}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div class={style.aipipeicon}>
                        {/* 网络素材 style={{ marginBottom: "20px" }} */}
                        <div class={style.mlist}>
                          <div class={style.lhd}>
                            <div class={style.conl}>
                              <div class={style.title}>网络素材</div>
                              <div class={style.tips}>
                                海量高质量素材库满足全场景视频制作2
                              </div>
                            </div>
                            <div class={style.conr}>
                              <label class={style.checkboxCon}>
                                <input
                                  type="checkbox"
                                  disabled={formInfo.input.aiPicture}
                                  checked={formInfo.input.useDigital}
                                  onChange={(e) => {
                                    const target = e.target as HTMLInputElement;
                                    setFormInfo((prev) => ({
                                      ...prev,
                                      input: { ...prev.input, useDigital: target.checked },
                                    }))
                                  }}
                                />
                                使用数字人
                              </label>
                            </div>
                          </div>
                          <div class={`${style.lbd} ${style.items}`}>
                            {products.map((item, index) => (
                              <div
                                key={index}
                                class={`${style.item} ${(formInfo.input.products[0] && formInfo.input.products[0].id === item.id) ? style.cur : ""}`}
                                onClick={(event) => onSelectProducts(item, event)}
                              >
                                <div class={style.pic}>
                                  <img src={item.thumb} alt={siteLang === 'en' && item.eng_title ? item.eng_title : item.title} />
                                </div>
                                <div class={`text-2-clamp ${style.name}`}>
                                  {siteLang === 'en' && item.eng_title ? item.eng_title : item.title}
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                        {/* AI素材 */}
                        <div class={style.mlist}>
                          <div class={style.lhd}>
                            <div class={style.conl}>
                              <div class={style.title}>AI素材</div>
                              <div class={style.tips}>
                                AI根据创作脚本自动生成风格场景素材
                              </div>
                            </div>
                            <div class={style.conr}></div>
                          </div>
                          <div class={`${style.lbd} ${style.items}`}>
                            {aiPictureStyle.map((item, index) => (
                              <div
                                key={index}
                                class={`${style.item} ${(formInfo.input.aiPictureStyle === item.value) ? style.cur : ""}`}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  onSelectAiPictureStyle(item);
                                }}
                              >
                                <div class={style.pic}>
                                  <img src={item.logo} alt={siteLang === 'en' && item.label_en ? item.label_en : item.label} />
                                </div>
                                <div class={`text-2-clamp ${style.name}`}>
                                  {siteLang === 'en' && item.label_en ? item.label_en : item.label}
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                      {/* <div class={style.aipipeibg} onClick={() => onChangeAiPiPei()}></div> */}
                    </div>
                  )}
                </div>

                <div class={style.btn} onClick={onChangeCategoryId}>
                  <span class={style.label}>比例</span>
                  <span class={style.value}>
                    {formInfo.input.categoryId === 1 ? "9:16" : "16:9"}
                  </span>
                  <span className="zk-iconfont zk-paixuxuanze"></span>
                </div>
                <div
                  class={`${style.btn} ${style.btnSend} ${formInfo.content ? style.btnSendok : ""}`}
                  onClick={createTask}
                >
                  <span className="zk-iconfont zk-zuojiantou1" style="color: #ffff; font-size: 22px; transform: rotate(90deg);"></span>
                </div>
              </div>
            </div>
          </div>
          <div class={style.modUse}>
            <div class={style.usehd}>
              <h1 class={style.title}>用例展示</h1>
              <div class={style.navsUse}>
                {categorys.map((item, index) => (
                  <div
                    key={index}
                    class={`${style.item} ${(item.value === tabValue) ? style.cur : ""}`}
                    onClick={() => setTabValue(item.value)}
                  >
                    {item.label}
                  </div>
                ))}
              </div>
            </div>
            <div className="usebd">
              {list.length > 0 ? (
                <div class={style.listUse}>
                  {list.map((item, index) => (
                    <div
                      key={index}
                      class={style.item}
                      onClick={() => window.open(`//ai.yiqijian.com/home?flow_id=${item.task.task_id}&act=auto&site_lang=zh`)}
                    >
                      <div class={style.boxcon}>
                        <div class={style.hdcon}>
                          {item.category_info?.value && (
                            <Fragment>
                              <span class={`zk-iconfont ${item.category_info.zkIconfont} ${style.iconTitle}`}></span>
                              <span class={style.title}>{item.category_info.label}</span>
                            </Fragment>
                          )}
                        </div>
                        <div class={`${style.text2Clamp} ${style.mtitle}`}>
                          {item.task.result.title}
                        </div>
                        <div class={style.bdcon}>
                          <div class={style.poscon}>
                            <span class={`zk-iconfont zk-xiushiyinhao ${style.icon}`}></span>
                            <p>{item.task.input.content}</p>
                          </div>
                        </div>
                      </div>
                      <div class={`${style.cover} ${(item.task.result.video_width > item.task.result.video_height ? style.coverh : style.coverv)}`}>
                        <img src={item.task.result.thumb} alt="缩略图" />
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div class={style.modDone}>
                  {loadingData ? (
                      <div class="a-spin" style={{ fontSize: "large" }}>加载中...</div>
                  ) : (
                    <div class="a-empty" style={{ textAlign: "center" }}>暂无数据</div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
      <section class={style.modeApi}>
        <div class={style.modeApiCon}>
          <h2 class={style.mtitle}>API</h2>
          <div class={style.mddesc}>
            <p>国内首家<span class={style.lang}>全面兼容MCP协议</span>的AI视频接口引擎</p>
            <p>已对接主流AI开放平台，赋能开发者快速集成智能视频创作模块</p>
          </div>
          <div class={style.loopLogos}>
            <div class={style.boxcon} id={`loopLogos`}>
              <div class={style.imgs}>
                <img alt="MPC" src="https://rmt-oss.zaker.cn/yiqijian_images/loop_logo1.png" />
                <img alt="DIFY" src="https://rmt-oss.zaker.cn/yiqijian_images/loop_logo2.png" />
                <img alt="扣子" src="https://rmt-oss.zaker.cn/yiqijian_images/loop_logo3.png" />
                <img alt="百度智能云千帆" src="https://rmt-oss.zaker.cn/yiqijian_images/loop_logo4.png" />
                <img alt="阿里云百炼" src="https://rmt-oss.zaker.cn/yiqijian_images/loop_logo5.png" />
                <img alt="腾讯云" src="https://rmt-oss.zaker.cn/yiqijian_images/loop_logo6.png" />
                <img alt="魔塔社区" src="https://rmt-oss.zaker.cn/yiqijian_images/loop_logo7.png" />

                <img alt="MPC" src="https://rmt-oss.zaker.cn/yiqijian_images/loop_logo1.png" />
                <img alt="DIFY" src="https://rmt-oss.zaker.cn/yiqijian_images/loop_logo2.png" />
                <img alt="扣子" src="https://rmt-oss.zaker.cn/yiqijian_images/loop_logo3.png" />
                <img alt="百度智能云千帆" src="https://rmt-oss.zaker.cn/yiqijian_images/loop_logo4.png" />
                <img alt="阿里云百炼" src="https://rmt-oss.zaker.cn/yiqijian_images/loop_logo5.png" />
                <img alt="腾讯云" src="https://rmt-oss.zaker.cn/yiqijian_images/loop_logo6.png" />
                <img alt="魔塔社区" src="https://rmt-oss.zaker.cn/yiqijian_images/loop_logo7.png" />
              </div>
            </div>
            <div class={style.conl}></div>
            <div class={style.conr}></div>
          </div>
          <p class={style.footMsg}>核心功能支持API对接，将一起剪创作能力无缝接入您的系统</p>
        </div>
      </section>
      <section class={style.modeBright}>
        <div class={style.modeBrightCon}>
          <h2 class={style.mtitle}>功能亮点</h2>
          <div class={style.mddesc}>
            <p>自研AI短视频创作驱动引擎，基于海量数据对短视频结构进行原子化解析实现自动生产高质量短视频</p>
            <p>满足营销推广、资讯传播、知识科普、故事创作等多种场景</p>
          </div>
          <div class={style.banner}>
            <img class={style.pic} alt="百万素材库" src="https://rmt-oss.zaker.cn/yiqijian_images/banner_next.png" />
            <div class={style.item}>
              <div class={style.poscon}>
                <div class={style.icon}>
                  <span class={`zk-iconfont zk-baiwansucaiku`}></span>
                </div>
                <h3 class={style.title}>百万素材库</h3>
                <p class={style.content}>影视级剪辑素材全覆盖，满足全场景创作需求。</p>
              </div>
              
            </div>
          </div>
          <div class={style.items}>
            <div class={style.item}>
              <div class={style.poscon}>
                <div class={style.icon}>
                  <span class={`zk-iconfont zk-kuamotaijiexi`}></span>
                </div>
                <h3 class={style.title}>一键“二创”</h3>
                <p class={style.content}>一键解析链接内容，自动生成风格化视频文案，重塑原创表达。</p>
              </div>
            </div>
            <div class={style.item}>
              <div class={style.poscon}>
                <div class={style.icon}>
                  <span class={`zk-iconfont zk-lianwangjiansuo`}></span>
                </div>
                <h3 class={style.title}>实时热点资讯</h3>
                <p class={style.content}>实时抓取最新资讯，智能整合全网信息，选题创作不发愁。</p>
              </div>
            </div>

            <div class={style.item}>
              <div class={style.poscon}>
                <div class={style.icon}>
                  <span class={`zk-iconfont zk-AIshuziren`}></span>
                </div>
                <h3 class={style.title}>AI数字人</h3>
                <p class={style.content}>丰富精美数字人形象，智能驱动口型动作。</p>
              </div>
            </div>
            <div class={style.item}>
              <div class={style.poscon}>
                <div class={style.icon}>
                  <span class={`zk-iconfont zk-xuqiujiexi`}></span>
                </div>
                <h3 class={style.title}>智能视频方案</h3>
                <p class={style.content}>AI深度解析用户意图，即使一句话也能生成完整视频方案。</p>
              </div>
            </div>
            <div class={style.item}>
              <div class={style.poscon}>
                <div class={style.icon}>
                  <span class={`zk-iconfont zk-yuyichaijie`}></span>
                </div>
                <h3 class={style.title}>内容深度创作</h3>
                <p class={style.content}>基于NLP的深度语义理解，自动拆解内容结构，并规划叙事节奏。</p>
              </div>
            </div>
            <div class={style.item}>
              <div class={style.poscon}>
                <div class={style.icon}>
                  <span class={`zk-iconfont zk-duomotaiduiqisuanfa`}></span>
                </div>
                <h3 class={style.title}>AI自动剪辑</h3>
                <p class={style.content}>自研多模态对齐算法，实现配音、字幕、画面同步精准对齐。</p>
              </div>
            </div>
            <div class={style.item}>
              <div class={style.poscon}>
                <div class={style.icon}>
                  <span class={`zk-iconfont zk-zhinengpeiyin`}></span>
                </div>
                <h3 class={style.title}>智能配音</h3>
                <p class={style.content}>多种优质音色可选，效果媲美真人。</p>
              </div>
            </div>
            <div class={style.item}>
              <div class={style.poscon}>
                <div class={style.icon}>
                  <span class={`zk-iconfont zk-hailiangpeile`}></span>
                </div>
                <h3 class={style.title}>海量配乐</h3>
                <p class={style.content}>智能推荐BGM，实现视频风格全覆盖。</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <PartnersView />
      
      {/*
      <div class={`${style.modal} ${playUrl ? style.active : ""}`}>
        <div class={style.modalClose} onClick={() => setPlayUrl("")}></div>
        {playUrl && <video controls autoPlay src={playUrl}></video>}
      </div>
      */}

    </div>
  );
};

export default Home;
